import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";


import {getPlayer} from "../../../services/player/player-service";
import DailyProgressCheckbox from "../../components/player-daily-progress/daily-progress-checkbox.js";

import SupinationPronationSection from "../../components/player-overview-charts/supination-pronation-section.js";

import {getPlayerProgress, getProgressKeys} from "../../../modules/result.js";

import PlayerProgressChart from "./player_progress_chart.js";

import PlayerDashboardButtons from "../../components/player-dashboard-buttons/player-dashboard-buttons";

import "./player_progress_dashboard.css";

// import {Col} from "reactstrap";

class PlayerProgressDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            player: -1,
            gameID: -1,
            skillID: -1,
            positionID: -1,
            progressKeys: [],
            loadingData: false,
            getData: false,
            chartsInfo: [],
            checkboxData: [],
            checkedCheckboxes: {},
            checkboxesChanged: false
        };

        
    }

    titleCase(str) {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            // You do not need to check if i is larger than splitStr length, as your for does that for you
            // Assign it back to the array
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
        }
        // Directly return the joined string
        return splitStr.join(' '); 
     }

    handleCheckboxChange(positionID, checked) {
        let {checkedCheckboxes} = this.state;

        let newCheckboxes = {...checkedCheckboxes};
        if (!checked) {
            delete newCheckboxes[positionID];
        }
        else {
            newCheckboxes[positionID] = true;
        }

        this.setState({
            checkedCheckboxes: newCheckboxes, 
            checkboxesChanged: true,
            getData: true
        })
    }

    preparePositionCheckboxes(progressKeys) {
        let positions = {};
        let checkboxData = [];

        let currentKeySet;
        for (let index in progressKeys) {
            currentKeySet = progressKeys[index];

            let positionName = currentKeySet.position_name;
            let positionID = currentKeySet.position_id;


            if (!positions[positionID]) {
                positions[positionID] = positionName;
                checkboxData.push({
                    position_id: positionID,
                    position_name: positionName
                });
            }
        }


        this.setState({checkboxData: checkboxData});
    }

    printCheckboxes() {
        let {checkboxData} = this.state;
        return checkboxData.map((item, index) => (
                <DailyProgressCheckbox position_id={item.position_id} position_name={item.position_name} handleClick={this.handleCheckboxChange.bind(this)}></DailyProgressCheckbox>
        ));
    }
    



    prepareProgressKeyStringName(keySet) {
        // let gameName = keySet.game_name;
        let skillName = keySet.skill_name;
        let positionName = keySet.position_name;
        let relevant_key = this.titleCase(keySet.relevant_key.replace(/_/g, " "));
        let funcType = keySet.func_type;
        let gameImagePath = keySet.game_image;
        return [skillName + ", " + positionName, relevant_key, funcType, gameImagePath];

    }

    shouldCheckProgressKey(progressKey) {
        let {checkedCheckboxes} = this.state;
        let positionID = progressKey.position_id;
        return checkedCheckboxes[positionID];
    }

    async getProgressKeysData(playerID) {        
        this.setState({loadingData: true});
        let {token} = this.props;
        let {progressKeys} = this.state;
        let chartsInfo = [];

        let currentKeySet;
        for (let index in progressKeys) {
            currentKeySet = progressKeys[index];
            if (!this.shouldCheckProgressKey(currentKeySet)) {
                continue;
            }
            
            let resultsInfo = await getPlayerProgress(playerID, currentKeySet.game_id, currentKeySet.skill_id, currentKeySet.position_id, currentKeySet.func_type, currentKeySet.relevant_key, token);                        
            if (resultsInfo && resultsInfo.data && resultsInfo.data.success) {
                chartsInfo.push([resultsInfo.data.data, this.prepareProgressKeyStringName(currentKeySet)]);
            }
        }
        
        let gotChartsInfo = false;
        let currentInfo;
        for (let index in chartsInfo) {
            currentInfo = chartsInfo[index];
            if (currentInfo[0] && typeof currentInfo === "object" && Object.keys(currentInfo[0]).length > 0) {
                gotChartsInfo = true;
                break;
            }
        }

        if (!gotChartsInfo) {
            chartsInfo = [];
        }

        this.setState({loadingData: false, chartsInfo: chartsInfo, getData: false});
    }

    async componentDidMount() { 
        let {token} = this.props;
        let {getData} = this.state;
        let progressKeys = await getProgressKeys(token);
                
        this.setState({progressKeys: progressKeys.data.data});   
        
        let playerID = this.props.match.params.id;        
        const player = await getPlayer(playerID, this.props);
        this.setState({player: player});
        if (playerID && getData) {
            this.setState({getData: false});
            this.getProgressKeysData(playerID);
        }   

        if (progressKeys.data.data) {
            this.preparePositionCheckboxes(progressKeys.data.data);
        }
        

         
    }

    componentDidUpdate() {
        let {getData} = this.state;
    
        let playerID = this.props.match.params.id; 
        if (playerID && getData) {
            this.setState({getData: false});
            this.getProgressKeysData(playerID);
        }   
    }

    render() {        
        let {loadingData, chartsInfo, player, getData, checkedCheckboxes} = this.state;


        let hasCheckedFilters = Object.entries(checkedCheckboxes).length !== 0 && checkedCheckboxes.constructor === Object
        return (
            <div>
                <PlayerDashboardButtons player={player} activePage="progressDashboard" isTherapistRole={true} />
                <div>Daily Progress Filters:</div>
                {this.printCheckboxes()}
                {loadingData && <div>Loading<i className='fa fa-spinner fa-spin'></i></div>}


                {!loadingData && chartsInfo.length > 0 && <div className='player_progress_dashboard_container'>
                    {chartsInfo.map((data) =>
                        <PlayerProgressChart title='a progress chart' data={data}></PlayerProgressChart>
                    )}
                </div>}

                {!loadingData && chartsInfo.length === 0 && !getData && hasCheckedFilters &&
                    <div className='player_progress_dashboard_no_data_message'>There is no progress data to show...</div>
                }
                {
                    !loadingData && chartsInfo.length === 0 && !getData && !hasCheckedFilters &&
                    <div className='player_progress_dashboard_no_data_message'>Select filters to see results</div>
                }

                {
                    this.props.angles_data && <SupinationPronationSection angle_data={this.props.angles_data} />
                }
            </div>
        );
    }
}

const withState = connect(state => {
    const {game, game_session, player, position, skill, user, result} = state;

    let games = game.games;
    let gameSessions = game_session.game_sessions;
    let players = player.players;
    let positions = position.positions;
    let skills = skill.skills;

    return {
        games: games,
        gameSessions: gameSessions,
        players: players,
        positions: positions,
        skills: skills,
        user: user,
        angles_data: result.angle_data,
        playerID: player.id,
        currentUserId: user.currentUserId,
        isTherapistRole: user.isTherapistRole,
        token: user.token
    };
});

export default withRouter(withState(PlayerProgressDashboard));


// WEBPACK FOOTER //
// ./src/components/containers/player-progress-dashboard/player-progress-dashboard.js